import axios from "axios"
const apiBaseUrl = process.env.REACT_APP_APIBASE_URL


export const uploadDesignApi = async formdata => {
    try {
      const apiToken = JSON.parse(localStorage.getItem("authUser")) 
      const headers = {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: apiToken,
        Accept: "application/json",
        "Cache-Control": "no-cache",
      };
      
      const response = await axios.post(`${apiBaseUrl}/superAdmin/SaveMarketingToolsDesign`, formdata, {
        headers,
      });
  
      return response;
    } catch (error) {
      console.error("Error Uploading Designs:", error);
      throw error;
    }
  }


  

export const getDesignsApi = async () => {
  try {
    const apiToken = JSON.parse(localStorage.getItem("authUser")) 
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    };
    
    const response = await axios.get(`${apiBaseUrl}/superAdmin/viewMarketingToolsDesign`, {
      headers,
    });

    return response;
  } catch (error) {
    console.error("Error Uploading Designs:", error);
    throw error;
  }
}


export const deleteDesignsApi = async (payload) => {
  try {
    const apiToken = JSON.parse(localStorage.getItem("authUser")) 
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    };
    
    const response = await axios.post(`${apiBaseUrl}/superAdmin/deleteMarketingToolsDesign`, payload,{
      headers,
    });

    return response;
  } catch (error) {
    console.error("Error Uploading Designs:", error);
    throw error;
  }
}